import React, { useState } from "react"
import { useTranslation } from "../i18n/TranslationProvider"

import { useHistory } from "react-router-dom"

import Form from "react-bootstrap/Form"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers"

import { Row, Col } from "react-bootstrap/"
import LabelledInput from "./LabelledInput"
import helpSchema from "./helpSchema"
import SubmitButton from "./StyledComponents/SubmitButton"
import Sallie from "./Sallie"
import LinkButton from "./StyledComponents/LinkButton"

import { postHelp } from "../api/helpReq"

const HelpPage = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [submitted, setSubmitted] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [err, setErr] = useState(false)

  const { errors, handleSubmit, register, reset } = useForm({
    resolver: yupResolver(helpSchema)
  })
  const onSubmit = data => {
    setSubmitting(true)
    data.email = data.email.toLowerCase();
    postHelp(data)
      .then(() => {
        setSubmitted(true)
        reset()
        setErr(false)
      })
      .catch(() => setErr(true))
      .finally(() => setSubmitting(false))
  }

  let SallieText;
  if (err) {
    SallieText = t("helpPage.sallieHelp.error");
  } else if (submitted) {
    SallieText = (
      <div>
        {t("helpPage.sallieHelp.submitted")} <LinkButton onClick={history.goBack}>{t("helpPage.helpPage.goBack")}</LinkButton>
      </div>
    )
  } else {
    SallieText = t("helpPage.sallieHelp.default");
  }

  return (
    <Row className="d-flex justify-content-center">
      <Col xs={10} md={8} lg={6}>
        <Sallie text={SallieText} />
        <Form className="mt-2" onSubmit={handleSubmit(onSubmit)}>
          <LabelledInput
            name="email"
            type="email"
            label={t("helpPage.helpPage.email")}
            labelAs="h6"
            errors={errors}
            inputRef={register}
            required
            autoFocus
          />
          <LabelledInput
            name="name"
            label={t("helpPage.helpPage.name")}
            labelAs="h6"
            errors={errors}
            inputRef={register}
            required
          />

          <LabelledInput
            labelAs="h6"
            inputAs="textarea"
            name="ticket"
            label={t("helpPage.helpPage.textareaLabel")}
            extraInfo={t("helpPage.helpPage.textareaInfo")}
            errors={errors}
            inputRef={register}
            required
          />
          <div className="d-flex justify-content-between">
            <SubmitButton onClick={history.goBack} type="button">
              {t("helpPage.helpPage.goBack")}
            </SubmitButton>
            <SubmitButton disabled={submitting} type="submit">
              {t("helpPage.helpPage.submit")}
            </SubmitButton>
          </div>
        </Form>
      </Col>
    </Row>
  )
}

export default HelpPage